<template>
<div v-if="showBidList">
	<table-list record-name="Bid"
		:fields="[
			{label: 'Active Bid', type: 'boolean',key:'is_active'},
			{label: 'Name',key: 'name'},
			{label: 'Revision #',key:'revision_num'},
			{label: 'Status',key: 'status'},
			{label: 'Date Created',key:'created_at'}
		]"
		:records="bids"
		:hide-record-count="true"
		id-field="slug"
		:has-edit="editLink"
		:has-delete="true"
		:other-buttons="[
			{
				text: 'Activate',
				icon: 'fa-check',
				class: 'btn-primary',
				click: 'activate',
				title: 'Active this bid as the active bid',
				condition: ['is_active',0]
			},
			{
				text: 'Clone Bid',
				icon: 'fa-copy',
				class: 'btn-light',
				click: 'cloneBid',
			}
		]"
		:collapse-buttons="false"
		delete-endpoint="JobBid/delete"
		v-on:cloneBid="cloneBid"
		v-on:activate="activateBid"
		v-on:modelChange="fetchBids">

		<div class="d-flex justify-content-between align-items-center">
			<h2 class="mb-0">
				Project Bids<br>
				<small v-if="$store.project && 'job_num' in $store.project">
					{{ $store.project.job_num }}: {{ $store.project.job_name}}
				</small>
			</h2>

			<div>
				<button class="btn btn-light mr-1" v-on:click="copyBidFromTemplates">
					<i class="fa fa-copy"></i>
					Copy from Templates...
				</button>

				<button class="btn btn-primary" v-on:click="newBid">
					<i class="fa fa-plus"></i>
					New Bid
				</button>
			</div>
		</div>

	</table-list>

	<modal-dialog title="Clone Bid"
		:modal-visible="cloneModal.visible"
		confirm-button-text="Clone"
		v-on:closeModal="cloneModal.visible = false"
		v-on:confirm="confirmCloneBid">

		<field label="Clone To"
			col-class="col-md-4"
			:params="{
				type: 'select',
				options: [
					{text: 'This project',value:'this-project'},
					{text: 'Bid Templates',value: 'templates'}
				]
			}"
			v-model="cloneModal.destination">
		</field>

		<field label="Scope"
			col-class="col-md-4"
			:params="{
				type: 'select',
				options: [
					{text: 'Whole Bid',value:'whole-bid'},
					{text: 'Structure Only',value: 'structure-only'}
				]
			}"
			v-model="cloneModal.cloneScope">
			<div class="text-muted">
				<p><strong>Whole Bid</strong> will clone all sub-components as well as all the elements (materials, equipment, labour, etc) added to subcomponents</p>
				<p><strong>Structure Only</strong> will clone only the sub-component structure, but not include any elements</p>
			</div>
		</field>

	</modal-dialog>

	<modal-dialog title="Copy from Bid Templates"
		:submit-visible="false"
		:modal-visible="copyFromTemplatesModal.visible"
		v-on:closeModal="copyFromTemplatesModal.visible = false">

		<table-list
			record-name="Bid Template"
			:fields="[
				{label: 'Name',key: 'name'},
				{label: 'Created',key:'createdAt'}
			]"
			:other-buttons="[
				{
					text: 'Copy',
					class: 'btn-primary',
					icon: 'fa-copy',
					click: 'copyTemplate'
				}
			]"
			v-on:copyTemplate="copyTemplate"
			:records="mutatedBidTemplates">
		</table-list>
	</modal-dialog>

</div>
<project-bid v-else></project-bid>
</template>
<script type="text/javascript">
import JobMixins from "@/mixins/JobMixins.js"

import TableList from "@/components/TableList"
import ProjectBid from "./ProjectBid"
import ModalDialog from "@/components/ModalDialog"
import Field from "@/components/Field"

export default {
	name: "ProjectBidding",
	components: {
		ProjectBid,
		TableList,
		ModalDialog,
		Field
	},
	mixins: [JobMixins],
	data() {
		return {
			bids: [],
			cloneModal: {
				visible: false,
				bid: null,
				destination: 'this-project',
				cloneScope: 'whole-bid'
			},
			copyFromTemplatesModal: {
				visible: false,
				templates: []
			}
		}
	},
	watch: {
		'$store.project'() {
			if (this.showBidList && "id" in this.$store.project)
				this.fetchBids(true)
		}
	},
	computed: {
		editLink() {
			return "/project/"+this.$store.project.slug+"/bidding/"
		},
		showBidList() {
			if ("tag" in this.$route.params && this.$route.params.tag) {
				//show single bid component
				return false
			}
			return true
		},
		mutatedBidTemplates() {
			let vm = this
			return this.copyFromTemplatesModal.templates.map(temp => {
				temp.createdAt = vm.formatDateTimeToLocal(temp.created_at)

				return temp
			})
		}
	},
	methods: {
		newBid() {
			let vm = this

			let payload = {
				is_active: 1,
				job_id: this.$store.project.id
			}

			this.postData("JobBid/save",payload,true).then(response => {
				if (response.success) {
					vm.$store.projectBidObjects = []
					vm.$router.push("/project/"+vm.$store.project.slug+"/bidding/"+response.slug)

				}
			})
		},
		copyBidFromTemplates() {
			let vm = this

			this.copyFromTemplatesModal.visible = true

			let params = {
				filters: [
					["template_category_id",this.$store.project.category_id],
					["is_template",1]
				]
			}

			this.spinner(true)

			this.getJSON("JobBid/get",params).then(response => {
				if (response.success)
					vm.copyFromTemplatesModal.templates = response.data

				vm.spinner(false)
			})
		},
		copyTemplate(template) {
			let vm = this

			let params = {
				bid_id: template.id,
				job_id: this.$store.project.id
			}

			this.postData("JobBid/clone-bid",params,true).then(response => {
				if (response.success) {
					vm.fetchBids(true)
					vm.copyFromTemplatesModal.visible = false
				}
			})
		},
		activateBid(record) {
			let vm = this

			let params = {
				id: record.id,
				is_active: 1
			}

			this.postData("JobBid/save",params,true).then(response => {
				if (response.success)
					vm.alertSuccess("Bid activated")
					vm.fetchBids(true)
			})
		},
		cloneBid(bid) {
			this.cloneModal.visible = true
			this.cloneModal.bid = bid
		},
		confirmCloneBid() {
			let vm = this

			let payload = {
				bid_id: this.cloneModal.bid.id,
				scope: this.cloneModal.cloneScope,
				is_template: this.cloneModal.destination == 'templates' ? 1 : 0
			}

			this.postData("JobBid/clone-bid",payload,true).then(response => {
				if (response.success) {
					vm.alertSuccess("Bid cloned")

					if (vm.cloneModal.destination == 'this-project')
						vm.fetchBids(true)

					vm.cloneModal.visible = false
				}
			})
		},
		fetchBids(spinner) {
			let vm = this

			let params = {
				filters: [
					["job_id",this.$store.project.id]
				]
			}

			if (spinner)
				vm.spinner(true)

			this.getJSON("JobBid/get",params).then(response => {
				if (spinner)
					vm.spinner(false)

				if (response.success)
					vm.bids = response.data
			})
		}
	},
	created() {
		if (this.showBidList && "id" in this.$store.project)
			this.fetchBids(true)
	}
}
</script>